var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getMsalApp } from './msalApp';
import { CHECK_FOR_SIGNEDIN_USER_COMMAND, OPEN_SIGNIN_DIALOG_COMMAND, SIGNIN_COMPLETE_EVENT, SIGNOUT_COMMAND, SIGNOUT_COMPLETE_EVENT } from './actions';
import { replace } from 'connected-react-router';
export function createAuthMiddleware() {
    return store => next => (action) => __awaiter(this, void 0, void 0, function* () {
        if (action.type === CHECK_FOR_SIGNEDIN_USER_COMMAND) {
            const msalApp = yield getMsalApp();
            if (!msalApp.getAccount()) {
                store.dispatch(replace('/signin'));
            }
        }
        if (action.type === OPEN_SIGNIN_DIALOG_COMMAND) {
            const msalApp = yield getMsalApp();
            msalApp
                .loginPopup({
                scopes: ['OnlineMeetings.ReadWrite']
            })
                .then(response => {
                console.log('Login succeeded');
                store.dispatch({
                    type: SIGNIN_COMPLETE_EVENT,
                    idToken: response.idToken
                });
            })
                .catch(error => {
                console.log('Login failed:', error);
            });
        }
        if (action.type === SIGNIN_COMPLETE_EVENT) {
            store.dispatch(replace('/'));
        }
        if (action.type === SIGNOUT_COMMAND) {
            const msalApp = yield getMsalApp();
            msalApp.logout();
            store.dispatch({
                type: SIGNOUT_COMPLETE_EVENT
            });
            console.log('logged out?');
        }
        next(action);
    });
}
